// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as ReactModal from "react-modal";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Button$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as CustomerApiHandler from "../state-machine/CustomerApiHandler.bs.js";
import * as FormInput$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as ModalStyles$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/modal/ModalStyles.bs.js";
import * as FormTitleBar$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormTitleBar.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";

function SendPaymentLinkModalCmp(Props) {
  var toggle_modal = Props.toggle_modal;
  var customer_id = Props.customer_id;
  var data = Props.data;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useState(function () {
        return "100";
      });
  var setAmount = match$1[1];
  var amount = match$1[0];
  var match$2 = React.useState(function () {
        return "";
      });
  var setSuccessMessage = match$2[1];
  var match$3 = React.useState(function () {
        return "";
      });
  var setFailureMessage = match$3[1];
  var match$4 = React.useState(function () {
        
      });
  var setValidationError = match$4[1];
  var validationError = match$4[0];
  React.useEffect((function () {
          var regex = /\b(?:[0-9]\100|[0-9]\d{1,2}|1000)0\b/;
          var validationResult = amount.length !== 0 ? regex.test(amount) : true;
          if (validationResult) {
            Curry._1(setValidationError, (function (param) {
                    
                  }));
          } else {
            Curry._1(setValidationError, (function (param) {
                    return {
                            TAG: /* Error */1,
                            _0: "Payment should be b/w 100 to 10000 and multiple of 10"
                          };
                  }));
          }
          
        }), [amount]);
  return React.createElement("div", {
              className: ""
            }, React.createElement(ReactModal, {
                  isOpen: true,
                  style: ModalStyles$Catalyst.getAlignContentCenterStyle(undefined, undefined),
                  ariaHideApp: false,
                  shouldCloseOnOverlayClick: true,
                  children: React.createElement("div", undefined, React.createElement(FormTitleBar$Catalyst.make, {
                            title: "Send Payment Link to: " + data.name + "(" + data.mobile + ")",
                            onCloseCb: (function (param) {
                                return Curry._1(toggle_modal, undefined);
                              })
                          }), React.createElement("div", {
                            className: "send_payment_link-modal"
                          }, React.createElement(FormTextInput$Catalyst.make, {
                                input_props: FormInput$Catalyst.make_props("Enter Payment Amount", (function ($$event) {
                                        return Curry._1(setAmount, (function (param) {
                                                      var value = FormHelper$Catalyst.TargetEventWrapper.value($$event);
                                                      var validationResult = /^[1-9][0-9]*$/.test(value);
                                                      if (validationResult) {
                                                        return value;
                                                      } else if (amount.length < 2) {
                                                        return "";
                                                      } else {
                                                        return amount;
                                                      }
                                                    }));
                                      }), undefined, undefined, "Enter Amount", undefined, undefined, undefined, validationError, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                textinput_props: {
                                  value: amount
                                }
                              }), React.createElement("div", {
                                className: "button-container"
                              }, React.createElement(Button$Catalyst.make, {
                                    text: "Close",
                                    cb: (function (param) {
                                        return Curry._1(toggle_modal, undefined);
                                      }),
                                    className: "btn-secondary"
                                  }), React.createElement(Button$Catalyst.make, {
                                    text: "Send Payment Link",
                                    cb: (function (_event) {
                                        return CustomerApiHandler.SendPaymentRequest.execute((function (data) {
                                                      return Curry._1(setSuccessMessage, (function (param) {
                                                                    return data.message;
                                                                  }));
                                                    }), (function (error) {
                                                      return Curry._1(setFailureMessage, (function (param) {
                                                                    return error._0.message;
                                                                  }));
                                                    }), customer_id, amount, country);
                                      }),
                                    className: "btn-primary",
                                    disabled: Belt_Option.isSome(validationError)
                                  })), React.createElement("div", {
                                className: "success"
                              }, match$2[0]), React.createElement("div", {
                                className: "failure"
                              }, match$3[0])))
                }));
}

var make = SendPaymentLinkModalCmp;

export {
  make ,
  
}
/* react Not a pure module */
